import { Amplify } from 'aws-amplify';

export const isGoogleSignInEnabled = !!import.meta.env.VITE_COGNITO_DOMAIN;

const awsConfig = {
  Auth: {
    Cognito: {
      userPoolId: import.meta.env.VITE_COGNITO_USER_POOL_ID,
      userPoolClientId: import.meta.env.VITE_COGNITO_CLIENT_ID,
      loginWith: {
        // Hosted-UI domain used only to broker "Sign in with Google" (e.g.
        // medease-prod.auth.ap-south-1.amazoncognito.com). Google sign-in is hidden when unset.
        oauth: {
          domain: import.meta.env.VITE_COGNITO_DOMAIN || '',
          scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
          redirectSignIn: [`${window.location.origin}/login`],
          redirectSignOut: [`${window.location.origin}/login`],
          responseType: 'code' as const,
        },
        email: true,
      },
    },
  },
  API: {
    REST: {
      MedEaseAPI: {
        endpoint: import.meta.env.VITE_API_BASE_URL,
        region: import.meta.env.VITE_AWS_REGION,
      },
    },
  },
};

Amplify.configure(awsConfig as any);

export default awsConfig;
